import styled from "styled-components";

export const CloseWrapper = styled.button`
    background: transparent;
    cursor: pointer;
    padding: 0 0.25rem;
    width: 1rem;
    float: right;
    border: 0;

    &:hover {
        background: ${globalThis.config.colors.gray2};
    }
`;

export const ContentWrapper = styled.div`
    margin-right: 2.5rem;
`;
